import { render } from "./TenantSelector.vue?vue&type=template&id=5a9d3232&scoped=true"
import script from "./TenantSelector.vue?vue&type=script&lang=js"
export * from "./TenantSelector.vue?vue&type=script&lang=js"

import "./TenantSelector.vue?vue&type=style&index=0&id=5a9d3232&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9d3232"]])

export default __exports__